import { useTranslation } from 'react-i18next';

/**
 * Status lines under OTP inputs: expiry countdown, resend wait, attempts left.
 */
export function OtpCountdownHint({
    ns = 'login',
    expired,
    expiresLabel,
    active,
    canResend,
    resendInSec,
    attemptsRemaining = null,
    maxAttempts = null,
    className = 'space-y-[var(--ds-space-1)] text-xs text-muted-foreground',
}) {
    const { t } = useTranslation(ns);

    if (!active) return null;

    return (
        <div className={className} aria-live="polite">
            {expired ? (
                <p>
                    {t('otp.expired', {
                        defaultValue: 'This code has expired. Request a new one.',
                    })}
                </p>
            ) : (
                <p>
                    {t('otp.expiresIn', {
                        defaultValue: 'Code expires in {{time}}',
                        time: expiresLabel,
                    })}
                </p>
            )}
            {!canResend && resendInSec > 0 && (
                <p>
                    {t('otp.resendIn', {
                        defaultValue: 'Resend available in {{seconds}}s',
                        seconds: resendInSec,
                    })}
                </p>
            )}
            {typeof attemptsRemaining === 'number' && (
                <p>
                    {t('otp.attemptsRemaining', {
                        defaultValue: '{{count}} of {{max}} attempts remaining',
                        count: attemptsRemaining,
                        max: maxAttempts || attemptsRemaining,
                    })}
                </p>
            )}
        </div>
    );
}

export default OtpCountdownHint;
